//export const API_URL = "http://46.202.167.211:8550/api/"
//export const API_URL = "http://localhost:8550/api/"
export const API_URL = "https://app.greenergysolution.in/api/"